var render = function render(){var _vm=this,_c=_vm._self._c;return _c('btn',{attrs:{"label":"2Easy","size":_vm.size},on:{"click":_vm.viewDocument}})
}
var staticRenderFns = []

export { render, staticRenderFns }